<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ------------------------------------------------ ----------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
<vs-alert color="danger" title="Class Room Not Found" :active.sync="ClassRoom_not_found">
      <span>Class Room record with id: {{ $route.params.Id }} {{$t('NotFound')}}. </span>
      <span>
        <span>{{$t('Check')}} </span><router-link :to="{name:'ClassRoom'}" class="text-inherit underline">All Class Room</router-link>
      </span>
    </vs-alert>
       

   <div  v-if="!ClassRoom_not_found||(this.$route.params.ID&&this.classRoomModel.ID)">
    <div class="vx-row">
    
    <div  class="vx-col lg:w-1/4 w-full">
     <vx-card :title="$t('ClassRoom')" class="mb-base">
      
          <div class="flex-1">
            <vs-input :label="$t('Name')" v-model="classRoomModel.Name" class="mt-5 w-full" name="name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>        
          </div>

          <div class="flex-1">
            <vs-input :label="$t('MaxNoOfTrainee')" v-model="classRoomModel.MaxNoOfTrainee" type="number" class="mt-5 w-full" name="MaxNoOfTrainee" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('MaxNoOfTrainee')">{{ errors.first('MaxNoOfTrainee') }}</span>        
          </div>
         <div class="flex-1">
            <vs-input :label="$t('DailyFees')" v-model="classRoomModel.DailyFees" type="number" class="mt-5 w-full" name="DailyFees" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('DailyFees')">{{ errors.first('DailyFees') }}</span>        
          </div>
      </vx-card>
</div>
<div  class="vx-col lg:w-3/4 w-full">
    <vx-card>
          <Class-Room-Facility class="mt-4" />
    </vx-card>
</div>
</div>
     <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
           <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{$t('Submit')}}</vs-button>
        <vs-button type="border" color="danger" :to="{name:'ClassRoom'}">{{$t('Cancel')}}</vs-button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>


<script>
import vSelect from 'vue-select'
import ClassRoomFacility from "./ClassRoomFacility.vue";
import moduleClassRoom from "@/store/settings/classRoom/moduleClassRoom.js";

export default {
  components: {
   ClassRoomFacility,
     vSelect,
 
  },
  data() {
    return {
      activePrompt:false,
      selected: [],
     
      itemsPerPage: 10,
      isMounted: false,
   
      // Data Sidebar
   
      classRoomModel: {},
      rowDataForDelete: {},
      activeConfirm: false,
      ClassRoom_not_found :false,
      facility:{},
    };
  },
  computed: {
   
   isFormValid() {
      return !this.errors.any() && this.classRoomModel.Name&&this.classRoomModel.MaxNoOfTrainee;
    },

  
  },

  methods: {
    
    initValues()
    {
       this.classRoomModel = {};
    },
   
     submitData() {
       this.classRoomModel.ClassRoomFacilities=this.$store.state.classRoomList.classRoomFacilities;
      this.$validator.validateAll().then(result => {
        if (result) {
         
          if (this.classRoomModel.ID !== null && this.classRoomModel.ID >= 0) {
            this.$store.dispatch("classRoomList/updateItem", this.classRoomModel).then(res => { 
               console.error(res);
              this.$router.push({name:"ClassRoom"});
           }).catch(err => {
              console.error(err);
            });
          
          } else {
            delete this.classRoomModel.ID;
            this.classRoomModel.popularity = 0;
            this.$store.dispatch("classRoomList/addItem", this.classRoomModel) 
            .then(res => { 
                console.error(res);
              this.$router.push("ClassRoom");
           }).catch(err => {
              console.error(err);
            });
              
          } 
          //this.initValues();    
        }
      });
    },

  },

  created() {
    if (!moduleClassRoom.isRegistered) {
      this.$store.registerModule("classRoomList", moduleClassRoom);
      moduleClassRoom.isRegistered = true;
    }
     const ID = this.$route.params.ID
     this.$store.commit("classRoomList/SET_ClassRoomFacilities",[]);
     if(ID!=undefined)
     {

      this.$store.dispatch("classRoomList/GetItemByID", ID)
      .then(res => { 
        debugger
        this.classRoomModel = res.data
       this.$store.commit("classRoomList/SET_ClassRoomFacilities", res.data.ClassRoomFacilities)

    
        debugger;
       })
      .catch(err => {
         debugger;
        if(err.response.status === 404) {
          this.ClassRoom_not_found = true
          return
        }
        console.error(err) })
     }
    
  },
  mounted() {
    this.isMounted = true;
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
